import { render, staticRenderFns } from "./programa-captura.vue?vue&type=template&id=44673c80&"
import script from "./programa-captura.component.ts?vue&type=script&lang=ts&"
export * from "./programa-captura.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports